const faqs = [
  {
    q: '鲁鲁影院真的完全免费吗？需要注册账号吗？',
    a: '是的，鲁鲁影院完全免费，无需注册即可在线观看所有内容。我们致力于为影迷提供零门槛的高清观影体验，没有任何隐藏收费或会员墙。',
  },
  {
    q: '视频播放卡顿怎么办？支持哪些清晰度？',
    a: '我们采用全球 CDN 加速技术，通常播放非常流畅。如果遇到卡顿，可以尝试切换清晰度（支持标清、高清和 1080P）。建议在网络环境良好的情况下选择高清以获得最佳体验。',
  },
  {
    q: '可以在手机和平板上观看吗？需要下载 App 吗？',
    a: '完全支持手机和平板设备，无需下载任何 App。只需使用浏览器访问鲁鲁影院，播放器会自动适配您的设备屏幕，支持横竖屏切换和手势控制。',
  },
  {
    q: '影片资源多久更新一次？能看到最新上映的电影吗？',
    a: '我们每天都会更新片源，热门剧集通常在播出后第一时间上线。新片上线时间取决于资源获取情况，编辑团队会以最快速度为大家带来最新内容。',
  },
  {
    q: '遇到播放错误或链接失效怎么办？',
    a: '如果遇到播放问题，请先尝试刷新页面或切换播放线路。若问题持续存在，可以通过联系页面的邮箱反馈给我们，技术团队会尽快修复。',
  },
];

export default function FaqSection() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900" style={{ fontFamily: 'var(--font-heading)' }}>
            常见问题
          </h2>
          <p className="mt-2 text-sm text-foreground-500">关于鲁鲁影院，你可能想了解这些</p>
        </div>
        <div className="max-w-2xl mx-auto">
          <div className="space-y-3">
            {faqs.map((item, i) => (
              <details key={i} className="group bg-background-50 rounded-xl border border-background-200/60">
                <summary className="flex items-center justify-between p-5 cursor-pointer list-none">
                  <h3 className="text-sm md:text-base font-bold text-foreground-900 pr-6">
                    {item.q}
                  </h3>
                  <span className="shrink-0 w-6 h-6 rounded-full bg-background-100 flex items-center justify-center group-open:rotate-45 transition-transform">
                    <i className="ri-add-line text-foreground-600 text-sm"></i>
                  </span>
                </summary>
                <div className="px-5 pb-5">
                  <p className="text-sm text-foreground-600 leading-relaxed">{item.a}</p>
                </div>
              </details>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}